export { default } from './ForecastGraphsCTADaySelector';
